{
  "meta": {
    "home": {
      "title": "BYHOURS : Réservez dans plus de 4 000 hôtels à l'heure",
      "description": "Réservez une chambre à l'heure dans votre hôtel préféré et décider de l'heure d'arrivée. Choisissez parmi plus de 4 000 hôtels de 3, 4 et 5 étoiles et réservez dans plus de 25 pays. Accédez à tous les services de l'hôtel avec annulation gratuite. Réservez dès maintenant avec BYHOURS, leader des micro-séjours.",
      "keywords": "hôtel par heures, hôtel à l heure, hôtels par heures, hôtel pour quelques heures, day use hôtel, hôtel de jour, day use hotel paris, day use paris, chambre par heure, chambre à l'heure, hotel journée, dayuse, day use, hotel day use, hôtel à l heure paris, hotel à l heure londres, hotel à l heure barcelone, hôtel à l heure madrid, day use pas cher, hotel de jour paris, hotel en journée, hotel a l heure, hotel en journée, hotel journee, micro-séjours, microséjou, chambre à la journée, chambre hotel a l'heure, expériences par heures, Hôtel de l'aéroport a l´heure, hôtel de l'aéroport, hôtel par heures aéroport,  dayuse, daybreak, byhours"
    },
    "search": {
      "title": "Hôtels à l'heure dans {city_name}",
      "description": "Les meilleurs hôtels de {city_name} disponibles à l'heure en packs de 3, 6 et 24 heures. Utilisation de jour comme de nuit avec accès à toutes les installations de l'hôtel. Annulation gratuite et enregistrement flexible.",
      "keywords": "hotel {city_name}, hôtels à l'heure à {city_name}, chambres à l'heure à {city_name} , hôtels à l'heure {city_name}, hôtels par heures {city_name}, réserver des hôtels à l'heure {city_name}, {city_name}, byhours, byhours {city_name}"
    },
    "detail": {
      "title": "{hotel_name} {city_name} pour 3, 6 ou 24 heures",
      "description": "Profitez de quelques heures de déconnexion à {hotel_name} dans {city_name} et ne payez que pour le temps dont vous avez besoin. Choisissez l'heure d'arrivée qui vous convient le mieux et profitez de toutes les installations. {hotel_description}",
      "keywords": "byhours {hotel_name}, by hours {hotel_name}, byhours.com {hotel_name}, day use {hotel_name}, hotel de jour {hotel_name}, hotel journée {hotel_name}, hotel à l heure {hotel_name}, {hotel_name} à l heure, {hotel_name}, {city_name}, chambre par heure {hotel_name}"
    },
    "landing": {
      "title": "Hôtels à l'heure dans {city_name}",
      "description": "Les meilleurs hôtels de {city_name} disponibles à l'heure en packs de 3, 6 et 24 heures. Utilisation de jour comme de nuit avec accès à toutes les installations de l'hôtel. Annulation gratuite et enregistrement flexible.",
      "keywords": "hotel {city_name}, hôtels à l'heure à {city_name}, chambres à l'heure à {city_name} , hôtels à l'heure {city_name}, hôtels par heures {city_name}, réserver des hôtels à l'heure {city_name}, {city_name}, byhours, byhours {city_name}"
    },
    "como-funciona": {
      "title": "Comment réserver des hôtels à l'heure",
      "description": "Découvrez comment en seulement 4 étapes simples, vous pouvez profiter de 3, 6 ou 24 heures dans un hôtel dans plus de 600 destinations.",
      "keywords": "doutes, étapes, comment réserver, byhours, hôtels à l'heure"
    },
    "byhours-destinations": {
      "title": "Réservez dans plus de 600 destinations",
      "description": "Réservez des chambres à l'heure dans votre hôtel préféré et décidez de l'heure d'arrivée. Choisissez parmi plus de 4 000 hôtels 3, 4 et 5 étoiles et réservez dans plus de 600 destinations. Accédez à tous les services de l'hôtel avec une annulation gratuite. Réservez dès maintenant avec BYHOURS, leader des micro-séjours.",
      "keywords": "destinations, byhours, hôtel"
    },
    "privacy": {
      "title": "Politique de confidentialité",
      "description": "Politique de confidentialité et de protection des données de BYHOURS. Informations sur le traitement de vos données personnelles lors de l'utilisation de nos services de réservation d'hôtels à l'heure."
    },
    "terms": {
      "title": "Conditions générales",
      "description": "Conditions générales d'utilisation du service BYHOURS. Conditions pour réserver des chambres d'hôtel à l'heure dans plus de 4 000 hôtels."
    },
    "onDemand": {
      "title": "BYHOURS On Demand — Demande de disponibilité",
      "description": "Dites-nous ce dont vous avez besoin et notre équipe vous aidera à trouver une disponibilité sur demande."
    },
    "hoteliers": {
      "title": "BYHOURS pour les hôteliers — Transformez les heures vides en revenus",
      "description": "Vendez des microséjours en tranches de 3, 6 et 24 heures selon vos règles : prix, disponibilité et canal propre. Sans quota minimum.",
      "ogTitle": "BYHOURS pour les hôteliers",
      "ogDescription": "Monétisez l’inventaire inoccupé avec des microséjours et un contrôle total depuis l’extranet."
    }
  },
  "stickyBookingBar": {
    "reservarAhora": "Réserver maintenant",
    "elegirHora": "Choisir l'heure",
    "aria": "Barre de réservation rapide"
  },
  "roomCard": {
    "badges": {
      "freeCancellation": "Annulation gratuite jusqu'à 24h",
      "payNow": "Payer maintenant",
      "payAtDestination": "Paiement sur place"
    },
    "packWindow": {
      "allDay": "Toute la journée"
    },
    "packOption": {
      "hours": "{count} heures",
      "vatIncluded": "TVA incluse",
      "availabilityTitle": "Disponibilité",
      "extraHourPromo": "Comprend 1h de séjour supplémentaire"
    },
    "realPrice": {
      "taxesIncluded": "Taxes et frais inclus",
      "taxesNotIncluded": "Taxes et frais non inclus",
      "taxesBreakdown": "Détail des taxes et frais"
    },
    "reserve": "Réserver"
  },
  "searchCard": {
    "urgency": {
      "oneRoom": "Il reste 1 chambre",
      "moreRooms": "Il reste {count} chambres"
    },
    "viewRooms": "Voir les chambres",
    "availablePacks": {
      "one": "Séjour de {pack}h",
      "many": "Séjours {packs}"
    },
    "promos": {
      "multiple": "{count} promotions",
      "modalTitle": "Promotions disponibles"
    }
  },
  "buttons": {
    "borrar": "Supprimer",
    "reiniciar": "Réinitialiser",
    "aplicar": "Appliquer",
    "cerrar": "Fermer",
    "filtros": "Filtres",
    "buscar": "Rechercher",
    "cargando": "Chargement",
    "mapa": "Carte mondiale",
    "buscarZona": "Rechercher dans cette zone",
    "filtroEntrada": "Heure d'arrivée",
    "eligeHorario": "Choisissez votre horaire",
    "continuar": "Continuer",
    "continuarSinExtras": "Continuer sans extras",
    "cancel": "Annuler",
    "buscarDia": "Rechercher un autre jour",
    "buscarOtroHotel": "Rechercher un autre hôtel",
    "noDispo": "Aucune disponibilité",
    "dispo": "Heure d'arrivée",
    "dispoOtrosDias": "Disponible d'autres jours",
    "moreImg": "Plus d'images",
    "readMore": "Lire plus",
    "readLess": "Lire moins",
    "reservar": "Réserver",
    "cancelBook": "Annuler la réservation",
    "modifyBook": "Modifier la réservation",
    "repeatBook": "Répéter la réservation",
    "deleteBook": "Supprimer la réservation",
    "clearHistory": "Effacer l'historique",
    "desde": "À partir de",
    "todos": "Tous",
    "login": "Se connecter",
    "verMapa": "Voir la carte",
    "compartir": "Partager",
    "guardar": "Enregistrer",
    "guardado": "Enregistré"
  },
  "labels": {
    "hoy": "Aujourd'hui",
    "mañana": "Demain",
    "dia": "jour",
    "dateRangeShortMinus1": "- 1 jour",
    "dateRangeShortPlus1": "+ 1 jour",
    "dateRangeShortBoth": "± 1 jour",
    "dateRangeMinus1": "Rechercher un jour avant",
    "dateRangePlus1": "Rechercher un jour après",
    "dateRangeBoth": "Rechercher un jour avant et après",
    "dateRangeSelector": "Élargir la recherche aux jours proches",
    "horas": "heures",
    "hoteles": "hôtels",
    "todoDia": "Toute la journée",
    "searchDestino": "Destinations correspondant à",
    "destinosPopulares": "Destinations populaires",
    "busquedasRecientes": "Recherches récentes",
    "placeholderDestino": "Rechercher une destination...",
    "ubicacion": "Emplacement",
    "rooms": "Chambres",
    "pack": "Forfait heures",
    "entrada": "Arrivée",
    "horarioReserva": "Horaire de réservation",
    "salida": "Sortie",
    "nombre": "Prénom",
    "apellido": "Nom de famille",
    "ciudad": "Ville",
    "telefono": "Téléphone",
    "extras": "Extras réservés",
    "password": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "repeatPassword": "Répétez le nouveau mot de passe",
    "passwordRequirements": {
      "length": "Au moins 8 caractères",
      "uppercase": "Au moins 1 lettre majuscule",
      "lowercase": "Au moins 1 lettre minuscule",
      "number": "Au moins 1 chiffre"
    },
    "email": "E-mail",
    "detalle": "Détails",
    "pago": "Informations de paiement",
    "pagado": "Payé",
    "total": "Total",
    "changePassword": "Changer le mot de passe",
    "precioHab": "par chambre",
    "errorHora": "Choisis ton heure de check-in",
    "errorHotel": "Nous n'avons pas trouvé l'hôtel",
    "errorDestino": "Destination non trouvée",
    "errorPaginaNoEncontrada": "Page non trouvée",
    "errorPaginaNoEncontradaSubtitle": "La page que vous recherchez n'existe pas.",
    "verHoteles": "Voir des hôtels à {city_name}",
    "verHotelesDisponibles": "Voir les {count} hôtels disponibles à {city_name}",
    "destacados": "Hôtels en vedette à {city_name}",
    "reserva": "Réservez votre hôtel à l'heure",
    "descubre": "Découvrez les hôtels à {city_name}",
    "hero": {
      "entradaFlexible": "Arrivée flexible",
      "hotelesVerificados": "Hôtels vérifiés",
      "sinNocheMinima": "Sans nuit minimum"
    },
    "comoFunciona": "Comment ça marche",
    "errorResultado": "Oups... Nous n'avons rien trouvé qui corresponde à votre recherche.",
    "errorResultadoTitle": "Aucun résultat",
    "destinos": "Destinations",
    "selectDestino": "Sélectionnez un pays",
    "ubicacionActual": "Emplacement actuel",
    "zonaActual": "Zone sélectionnée",
    "selectCity": "Sélectionnez une ville",
    "sinDisponibilidadTitle": "Pas de disponibilité pour le moment",
    "sinDisponibilidadDescription": "Il n'y a actuellement aucun hôtel disponible dans cette destination. Nous vous invitons à revenir plus tard ou à explorer d'autres options.",
    "buscarOtroDestino": "Rechercher une autre destination",
    "buscarOtraUbicacion": "Rechercher un autre emplacement",
    "numRooms": "Nº chambres",
    "ariaLabelHorarioFlexible": "Informations horaire flexible",
    "aria": {
      "home": "Accueil",
      "idiomaMoneda": "Langue et devise",
      "usuario": "Utilisateur",
      "menu": "Menu",
      "favorito": "Favori",
      "compartir": "Partager",
      "info": "Information",
      "diaAnterior": "Jour précédent",
      "diaSiguiente": "Jour suivant",
      "descargarAppIos": "Télécharger l'application pour iOS",
      "descargarAppAndroid": "Télécharger l'application pour Android",
      "showPassword": "Afficher le mot de passe",
      "hidePassword": "Masquer le mot de passe"
    },
    "login": {
      "title": "Bienvenue sur BYHOURS",
      "password": "Mot de passe oublié ?",
      "session": "Se connecter",
      "noAccount": "Vous n'avez pas de compte ?",
      "registerLabel": "S'inscrire",
      "placeholder": {
        "email": "Adresse e-mail *",
        "password": "Mot de passe *"
      },
      "continue": "Continuer",
      "o": "OU",
      "recover": {
        "title": "Récupérez votre mot de passe",
        "subtitle": "Entrez votre adresse e-mail et nous vous enverrons les instructions pour réinitialiser votre mot de passe.",
        "subtitle2": "Entrez votre nouveau mot de passe et confirmez-le.",
        "back": "Retour à la connexion"
      },
      "register": {
        "title": "Créez votre compte sur BYHOURS",
        "account": "Vous avez déjà un compte ?"
      },
      "google": "Continuer avec Google",
      "facebook": "Continuer avec Facebook",
      "footer": {
        "user": "Conditions d'utilisation",
        "privacy": "Politique de confidentialité",
        "cookies": "Politique relative aux cookies"
      },
      "emailConfirmation": {
        "title": "Confirmez votre adresse e-mail !",
        "subtitle": "Nous avons envoyé un e-mail à {email} avec un lien pour confirmer votre adresse e-mail. Si vous ne le voyez pas dans votre boîte de réception, vérifiez le dossier spam.",
        "resend": "Renvoyer l'e-mail"
      },
      "dropdown": {
        "perfil": "Profil",
        "cerrar": "Se déconnecter"
      }
    },
    "proximaReserva": {
      "titulo": "Prochaine réservation",
      "ver": "Voir la réservation",
      "repetir": "Répéter la réservation",
      "repetirSubtitulo": "Il y a {days} jours",
      "repetirSubtituloHoy": "Réservé aujourd'hui",
      "repetirSubtituloAyer": "Réservé hier",
      "repetirDescripcion": "Réservé il y a {days} jours à {hotel}",
      "repetirDescripcionHoy": "Réservé aujourd'hui à {hotel}",
      "repetirDescripcionAyer": "Réservé hier à {hotel}"
    },
    "user_zone": {
      "emailVerified": {
        "title": "E-mail vérifié",
        "description": "Vous pouvez maintenant utiliser l'espace utilisateur normalement."
      },
      "menu": {
        "perfil": "Profil",
        "reservas": "Mes réservations",
        "favoritos": "Favoris",
        "inicio": "Accueil BYHOURS",
        "cerrarSesion": "Se déconnecter"
      },
      "favoritos": {
        "noFavoritosTitle": "Vous n'avez pas encore de favoris",
        "noFavoritosSubtitle": "Qu'attendez-vous ? Marquez vos hôtels favoris",
        "completeProfile": "Vous devez compléter votre profil pour pouvoir ajouter des hôtels aux favoris"
      },
      "perfil": {
        "danger": "Zone dangereuse",
        "deleteAccount": "Supprimer le compte",
        "deleteAccountText": "Êtes-vous sûr de vouloir supprimer votre compte ?",
        "deleteAccountText2": "Cette action est permanente et ne peut pas être annulée. Toutes vos données seront définitivement supprimées.",
        "successUpdate": "Les informations ont été mises à jour avec succès",
        "successDelete": "L'utilisateur a été supprimé avec succès"
      },
      "reservas": {
        "noReservasTitle": "Vous n'avez pas encore de réservations",
        "noReservasSubtitle": "Qu'attendez-vous ? Réservez votre chambre avec nous",
        "activas": "Actives",
        "pasadas": "Passées",
        "cancelled": "Annulées",
        "cancel": "Réservation annulée avec succès",
        "cancelError": "Erreur lors de l'annulation de la réservation",
        "reference": "Référence",
        "price": "Prix",
        "cancelText": "Êtes-vous sûr de vouloir annuler la réservation ?",
        "cancelText2": "Si vous annulez maintenant, vous pourriez perdre votre réservation actuelle.",
        "deleteText": "Êtes-vous sûr de vouloir supprimer cette réservation ?",
        "deleteText2": "Cette action est permanente et vous ne pourrez pas récupérer la réservation.",
        "deleteSuccess": "Réservation supprimée avec succès",
        "deleteError": "Erreur lors de la suppression de la réservation",
        "clearHistoryText": "Êtes-vous sûr de vouloir effacer tout l'historique ?",
        "clearHistoryText2": "Toutes vos réservations passées seront définitivement masquées.",
        "clearHistorySuccess": "Historique effacé avec succès",
        "clearHistoryError": "Erreur lors de l'effacement de l'historique",
        "detalle": {
          "titulo": "Détails de la réservation",
          "tiempo": "Durée du séjour"
        }
      }
    },
    "cancelBook": {
      "title": "Annuler la réservation",
      "subtitle": "Saisissez votre code de réservation et l'e-mail utilisé lors de la réservation. L'annulation n'est possible que si les conditions d'annulation sont respectées (par exemple au moins 24 h avant l'arrivée).",
      "referenceError": "Saisissez votre code de réservation",
      "referencePlaceholder": "Code de réservation",
      "emailPlaceholder": "E-mail",
      "submit": "Annuler la réservation",
      "success": "La réservation a été annulée avec succès",
      "genericError": "Impossible d'annuler la réservation",
      "backHome": "Retour à l'accueil"
    },
    "tags": {
      "piscina": "Profitez de l'accès à la piscine inclus avec votre réservation ! 💦"
    },
    "tooltips": {
      "packHours": "Vous pouvez réserver {hours}h dans ce créneau",
      "horarioFlexible": "Votre arrivée est flexible dans l'horaire affiché, mais le départ doit être ponctuel."
    },
    "extraHours": {
      "maxExtraHours": "Un maximum de {hours} heures supplémentaires peut être ajouté",
      "noExtraHours": "Aucune heure supplémentaire ne peut être ajoutée à l'heure sélectionnée"
    },
    "horasDisponibles": "Heures disponibles",
    "gratis": "Gratuit"
  },
  "errors": {
    "search": "Une erreur est survenue lors de la recherche d'hôtels. Veuillez réessayer.",
    "ubicacion": {
      "support": "Il semble que votre navigateur ne prend pas en charge la fonction de géolocalisation. Essayez un autre navigateur ou activez l'option dans les paramètres.",
      "block": "La localisation est bloquée dans votre navigateur. Pour l'activer, allez dans les paramètres et autorisez l'accès à la localisation.",
      "permission": "Nous n'avons pas pu accéder à votre localisation car vous avez refusé la permission. Vous pouvez l'activer dans les paramètres de votre appareil.",
      "gps": "Nous n'avons pas pu déterminer votre localisation. Assurez-vous que le GPS est activé et que vous avez une connexion stable.",
      "timeout": "La demande de localisation prend plus de temps que prévu. Veuillez réessayer dans quelques instants.",
      "error": "Une erreur s'est produite lors de la tentative de récupération de votre localisation. Veuillez réessayer."
    },
    "login": {
      "email": "Email invalide",
      "password": "Au moins 8 caractères",
      "passwordComplexity": "Doit contenir au moins une lettre majuscule, une lettre minuscule et un chiffre",
      "repeatPassword": "Les mots de passe ne correspondent pas",
      "emailDomain": "Le domaine de l'email ne semble pas valide",
      "facebook_email_required": "Facebook n'a pas partagé votre email avec nous. Pour vous connecter avec Facebook sur BYHOURS, allez dans vos paramètres d'applications Facebook et accordez l'autorisation email à BYHOURS.",
      "email_verified": "E-mail confirmé. Connectez-vous pour continuer.",
      "email_verification_failed": "Nous n'avons pas pu confirmer votre e-mail avec ce lien. S'il est déjà confirmé, connectez-vous. Sinon, allez dans l'espace utilisateur et renvoyez l'e-mail."
    },
    "user_zone": {
      "delete": "Erreur lors de la suppression de l'utilisateur",
      "password": "Erreur lors du changement de mot de passe",
      "email_verification_failed": "Nous n'avons pas pu confirmer votre e-mail avec ce lien. S'il était déjà confirmé, l'espace se débloquera à l'actualisation. Sinon, renvoyez l'e-mail de confirmation."
    }
  },
  "share": {
    "copy": "Copier le lien",
    "whatsapp": "Partager sur WhatsApp",
    "email": "Partager par e-mail",
    "message": "Bonjour ! Je partage avec toi cet hôtel qui m'a semblé intéressant : {url}"
  },
  "checkout": {
    "meta": {
      "title": "Paiement",
      "description": "Finalisez votre réservation"
    },
    "timer": "Votre chambre est réservée pendant {time} minutes",
    "steps": {
      "checkinHour": "Heure d'arrivée",
      "data": "Vos informations",
      "payment": "Paiement sécurisé",
      "back": "Retour"
    },
    "sections": {
      "completeCheckinHour": "Sélectionnez l'heure d'arrivée pour continuer"
    },
    "checkinHour": {
      "title": "Heure d'arrivée",
      "subtitle": "Choisissez votre heure d'entrée",
      "required": "Sélectionnez une heure d'entrée pour continuer",
      "pendingSummary": "Sélectionnez votre heure d'entrée",
      "description": "Choisissez votre heure d'entrée dans {window} ; à partir de cette heure, vous profiterez de {hours} heures de séjour.",
      "descriptionNoWindow": "Choisissez votre heure d'entrée ; à partir de cette heure, vous profiterez de {hours} heures de séjour.",
      "placeholder": "Choisissez votre heure d'entrée",
      "changeHour": "Modifier l'heure d'entrée",
      "descriptionSelected": "Arrivée flexible à partir de {checkin}. Votre chambre est disponible de {checkin} à {checkout}."
    },
    "extras": {
      "title": "Extras",
      "continueWithout": "Continuer sans extras",
      "noneForHour": "Aucun extra disponible pour l'heure sélectionnée"
    },
    "recovery": {
      "title": "Vous avez une réservation en cours",
      "finishBooking": "Finaliser ma réservation",
      "closeAria": "Fermer le rappel"
    },
    "contactData": {
      "title": "Données de contact",
      "loginPrompt": "Vous avez déjà un compte ?",
      "loginButton": "Se connecter",
      "registerButton": "S'inscrire",
      "loginPromptSuffix": "pour accélérer vos futures réservations.",
      "continueAsGuest": "Continuer en tant qu'invité",
      "firstName": "Prénom",
      "firstNamePlaceholder": "Jean",
      "lastName": "Nom",
      "lastNamePlaceholder": "Dupont",
      "email": "E-mail",
      "emailPlaceholder": "jean.dupont{'@'}byhours.com",
      "phone": "Téléphone",
      "phonePlaceholder": "0612345678",
      "city": "Ville",
      "cityPlaceholder": "Paris"
    },
    "promoCode": {
      "title": "Code promotionnel",
      "placeholder": "Exemple : ETE10",
      "apply": "Appliquer",
      "applied": "Code promotionnel appliqué",
      "remove": "Supprimer",
      "errors": {
        "required": "Entrez un code promotionnel valide",
        "invalid": "Code promotionnel invalide",
        "generic": "Erreur lors de l'application du code promotionnel"
      }
    },
    "comments": {
      "title": "Commentaires pour l'hôtel",
      "placeholder": "Exemple : 'J'ai besoin d'une chambre adaptée pour fauteuil roulant'"
    },
    "payment": {
      "title": "Méthode de paiement"
    },
    "trustBadges": {
      "securePayment": "Paiement sécurisé (Stripe)",
      "freeCancellation": "Annulation gratuite",
      "encryptedData": "Données cryptées"
    },
    "terms": {
      "text": "En réservant, vous acceptez notre",
      "userAgreement": "Accord d'utilisateur",
      "privacyText": "Chez BYHOURS, nous traiterons vos données personnelles pour gérer votre réservation et vous tenir informé tout au long du processus.",
      "privacyInfo": "Pour plus d'informations, consultez notre",
      "privacyPolicy": "Politique de confidentialité"
    },
    "buttons": {
      "continue": "Continuer",
      "confirmAndPay": "Confirmer et payer maintenant",
      "payNow": "Payer maintenant"
    },
    "loading": "Traitement du paiement...",
    "summary": {
      "hotel": "Hôtel",
      "address": "Adresse",
      "checkIn": "Arrivée",
      "checkOut": "Départ",
      "hotelTaxes": "Taxes et frais de l'hôtel",
      "hotelTaxesTooltip": "Selon la destination, certaines taxes et/ou frais (comme la taxe de séjour) peuvent ne pas être inclus dans le prix et doivent être payés directement à l'hôtel",
      "bookingFees": "Frais de réservation",
      "bookingFeesTooltip": "Frais au titre de frais de gestion",
      "promoDiscount": "Remise promotionnelle",
      "payAtHotel": "À payer à l'hôtel",
      "payAtHotelTooltip": "Le paiement sera effectué dans la devise de l'établissement (le taux de change peut varier)",
      "payNow": "Tu ne paies que",
      "total": "TOTAL",
      "taxesIncluded": "Taxes et frais inclus",
      "additionalTaxesSuffix": "taxes et frais supplémentaires",
      "additionalTaxesBody": "Les taxes et frais ne sont pas inclus et se règlent directement à l'hôtel",
      "freeCancellation": "Annulation gratuite jusqu'à 24h avant l'arrivée ; après, l'hôtel peut facturer le montant intégral.",
      "paymentSplit": "Vous ne payez que {nowAmount} maintenant, le reste ({hotelAmount}) à payer à l'hôtel.",
      "seeDetails": "Voir les détails",
      "taxesInfo": "Certaines taxes et/ou frais (comme la taxe de séjour) peuvent ne pas être inclus dans le prix final et doivent être payés directement à l'hôtel"
    },
    "paymentDetails": {
      "title": "Détails du paiement et de l'annulation",
      "paymentCharges": {
        "title": "Paiement et charges",
        "item1": "Le débit que vous verrez sur votre compte sera : \"Travel Payment\".",
        "item2": "Vous ne payez qu'une partie maintenant (frais de gestion) et le reste du montant est payé directement à l'hôtel.",
        "item3": "Vous payez le montant total de l'hébergement à l'avance."
      },
      "cancellations": {
        "title": "Annulations et non-présentations",
        "item1": "Vous pouvez annuler votre réservation jusqu'à 24h avant l'arrivée.",
        "item2": "Si vous annulez à temps, nous vous rembourserons le montant payé.",
        "item3": "L'hôtel se réserve le droit de facturer 100% du montant si vous ne vous présentez pas ou annulez hors délai."
      },
      "checkIn": {
        "title": "Check-in",
        "idRequired": "La présentation d'une pièce d'identité valide (carte d'identité ou passeport) est obligatoire pour toutes les personnes qui séjournent."
      },
      "support": {
        "title": "Service client",
        "scheduleMondayThursday": "Lundi à Jeudi de 9h à 24h (UTC/GMT +1)",
        "scheduleFriday": "Vendredi de 9h à 21h (UTC/GMT +1)",
        "scheduleWeekend": "Samedis, Dimanches et jours fériés de 9h30 à 18h30 (UTC/GMT +1)",
        "whatsapp": "Vous pouvez nous contacter par",
        "email": "Vous pouvez nous écrire à :",
        "phones": "Téléphones de contact",
        "uk": "Royaume-Uni :",
        "france": "France :",
        "mexico": "Mexique :",
        "colombia": "Colombie :",
        "spain": "Espagne :"
      }
    },
    "errors": {
      "title": "Erreur",
      "firstNameRequired": "Le prénom est obligatoire",
      "lastNameRequired": "Le nom est obligatoire",
      "emailRequired": "L'e-mail est obligatoire",
      "emailInvalid": "E-mail invalide",
      "phoneInvalid": "Le numéro de téléphone ne peut contenir que des chiffres",
      "stripeNotAvailable": "Stripe n'est pas disponible",
      "initializePaymentError": "Erreur lors de l'initialisation du paiement",
      "initializePaymentRetry": "Impossible d'initialiser le paiement. Veuillez réessayer.",
      "clientSecretError": "Impossible d'obtenir le client secret",
      "paymentContainerError": "Le conteneur de paiement n'est pas disponible après plusieurs tentatives",
      "bookingInitError": "Impossible d'initialiser la réservation",
      "paymentElementsError": "Éléments de paiement non initialisés",
      "confirmPaymentError": "Erreur lors de la confirmation du paiement",
      "paymentIntentError": "Impossible d'obtenir le payment intent",
      "paymentIncompleteError": "Le paiement n'a pas été complété avec succès. Statut : {status}",
      "authenticationFailure": "La vérification bancaire n'a pas pu aboutir. Saisis à nouveau ta carte. Si ça continue, essaie un nouvel onglet en navigation privée ou l'application.",
      "bookingConfirmError": "Erreur lors de la confirmation de la réservation",
      "unexpectedPaymentError": "Erreur inattendue lors du processus de paiement",
      "preBooking": {
        "noAvailability": {
          "title": "Cette option n'est plus disponible",
          "description": "Veuillez choisir une autre chambre à l'hôtel."
        },
        "hourUnavailable": {
          "title": "Cette heure n'est plus disponible",
          "description": "Veuillez essayer une autre heure d'arrivée."
        },
        "retryable": {
          "title": "Nous n'avons pas pu continuer",
          "description": "Veuillez réessayer dans un instant."
        },
        "network": {
          "title": "Problème de connexion",
          "description": "Vérifiez votre connexion et réessayez."
        },
        "missingData": {
          "title": "Informations manquantes",
          "description": "Veuillez vérifier vos coordonnées et réessayer."
        },
        "blacklist": {
          "title": "Réservation impossible",
          "description": "Veuillez nous contacter pour continuer."
        },
        "duplicatedBook": {
          "title": "Nous n'avons pas pu continuer",
          "description": "Vérifiez vos réservations ou réessayez dans quelques minutes."
        },
        "invalidPromo": {
          "title": "Code promotionnel invalide",
          "description": "Retirez-le et réessayez."
        },
        "paymentFailed": {
          "title": "Impossible de démarrer le paiement",
          "description": "Veuillez réessayer dans un instant."
        },
        "actions": {
          "changeHour": "Choisir une autre heure",
          "viewHotel": "Voir l'hôtel",
          "retry": "Réessayer",
          "reviewData": "Vérifier mes données",
          "removePromo": "Retirer le code et réessayer",
          "myBookings": "Voir mes réservations"
        }
      }
    }
  },
  "confirm": {
    "meta": {
      "title": "Paiement réussi",
      "description": "Votre réservation a été confirmée"
    },
    "header": {
      "title": "Paiement réussi !",
      "subtitle": "Votre réservation a été confirmée",
      "reference": "Référence :"
    },
    "loading": "Vérification du paiement...",
    "personalData": {
      "title": "Données personnelles",
      "name": "Prénom",
      "lastName": "Nom",
      "email": "E-mail",
      "phone": "Téléphone"
    },
    "location": {
      "title": "Emplacement"
    },
    "help": {
      "title": "Besoin d'aide ?"
    },
    "buttons": {
      "viewBookings": "Voir mes réservations",
      "searchMore": "Rechercher plus d'hôtels"
    }
  },
  "onDemandPage": {
    "title": "Pas de disponibilité ? Nous nous en chargeons pour vous",
    "subtitle": "Dites-nous ce que vous cherchez : notre équipe étudie les options de séjour à l'heure pour votre destination et vos dates.",
    "sections": {
      "contact": "Coordonnées",
      "trip": "Destination et dates",
      "additional": "Informations complémentaires"
    },
    "fields": {
      "name": "Nom",
      "email": "E-mail",
      "destination": "Destination",
      "destinationPlaceholder": "Rechercher une ville",
      "checkinDate": "Date d'arrivée",
      "checkinTime": "Heure d'arrivée",
      "pack": "Pack heures",
      "summary": "Résumé",
      "attemptedBooking": "Qu'avez-vous essayé de réserver ?",
      "attemptedPlaceholder": "Hôtel, lien ou détails du séjour recherché"
    },
    "privacy": {
      "checkboxBefore": "J'accepte la ",
      "link": "politique de confidentialité",
      "checkboxAfter": " et le traitement de mes données pour traiter cette demande."
    },
    "submit": "Envoyer la demande",
    "backHome": "Retour à l'accueil",
    "success": {
      "title": "Demande reçue",
      "body": "Nous avons enregistré votre demande. Nous vous contacterons dès que possible.",
      "backSearch": "Retour à la recherche d'hôtels"
    },
    "errors": {
      "required": "Ce champ est obligatoire",
      "email": "E-mail invalide",
      "privacy": "Vous devez accepter la politique de confidentialité",
      "attemptedMax": "Texte trop long",
      "generic": "Impossible d'envoyer la demande. Réessayez.",
      "rateLimit": "Trop de demandes envoyées. Réessayez dans quelques minutes.",
      "timeOnTheHour": "Choisissez une heure pile",
      "validationToastTitle": "Envoi impossible",
      "checkinPast": "La date et l’heure d’arrivée doivent être postérieures au moment actuel.",
      "roomsRange": "Choisissez entre 1 et 10 chambres"
    }
  },
  "strapi": {
    "hotelPage": {
      "descripcion": "Description",
      "ubicacion": "Emplacement",
      "servicios": "Services",
      "reserva": "Réserver une chambre",
      "verHabitaciones": "Voir les chambres",
      "preguntas": "Questions fréquentes",
      "info": "Informations importantes",
      "distance_airport": "Distance de l'aéroport",
      "shuttle_service": "Service de navette",
      "shuttle_service_information": "Informations sur le service de navette",
      "taxi_distance": "Distance en taxi",
      "public_transport": "Transports publics",
      "noRooms": "Toutes les chambres disponibles pour cet hôtel sont épuisées pour la date sélectionnée",
      "noRoomsEmpty": {
        "titulo": "Aucune chambre pour cette date",
        "descripcion": "Les chambres sont complètes pour le jour choisi. Choisissez une autre date disponible."
      },
      "extraDescription": "Choisissez des extras pour compléter votre expérience BYHOURS",
      "extra": {
        "titulo": "Extras",
        "subtitulo": "Les extras peuvent être ajoutés après la sélection de la chambre"
      },
      "max_pers": {
        "titulo": "Maximum",
        "subtitulo": "personnes"
      },
      "noDispo": {
        "titulo": "Aucune disponibilité dans cet hôtel",
        "subtitulo": "Actuellement indisponible",
        "descripcionAmigable": "Aucune disponibilité dans cet hôtel pour le moment."
      },
      "hotelesCercanos": "Découvrez plus d'hôtels à proximité"
    },
    "searchPage": {
      "filtroHora": "Heure d'arrivée",
      "resultados": "hôtels à l'heure à",
      "filtroPack": "Pack",
      "filtroPromo": "Promotion",
      "filtroPrecio": "Prix",
      "filtroEstrella": "Catégorie",
      "filtroServicio": "Services",
      "resultadosAlternativos": "Voir d'autres hôtels à",
      "resultadosNear": "Hôtels à proximité",
      "horasEntrada": "Heures d'enregistrement disponibles",
      "sinHorasEntrada": "Non disponible",
      "searchZona": "Rechercher dans cette zone",
      "sinResultados": {
        "titulo": "Oh non :-( Aucun hôtel disponible pour votre recherche, essayez un autre jour, une autre heure ou une autre destination.",
        "subtitulo": null
      },
      "sinResultadoFiltro": {
        "titulo": "Il n'y a pas d'hôtels avec les filtres sélectionnés",
        "subtitulo": null
      },
      "sinHoteles": {
        "titulo": "Eh ben ! Nous proposons 600 villes avec des hôtels réservables à l'heure, mais vous avez quand même réussi à en trouver une où nous ne sommes pas encore disponibles.",
        "subtitulo": null
      },
      "onDemand": {
        "titulo": "Vous ne trouvez pas ce que vous cherchez?",
        "subtitulo": "Nous le trouverons en moins de 24 heures!"
      },
      "buscandoFechasCercanas": "Recherche de disponibilité à d'autres dates…",
      "disponiblesFechasCercanas": "Disponibles à des dates proches à",
      "disponibleEl": "Disponible le",
      "probarOtraFecha": "Essayer une autre date :",
      "chipManana": "Demain",
      "chipPasadoManana": "Après-demain",
      "ordenacion": [
        "Pertinence",
        "Prix (par ordre croissant)",
        "Prix (par ordre décroissant)",
        "Catégorie (par ordre croissant)",
        "Catégorie (par ordre décroissant)"
      ]
    },
    "homePage": {
      "labelHoteles": "Voir plus d'hôtels à"
    },
    "global": {
      "header": {
        "tituloIdioma": "Langue",
        "tituloMoneda": "Devise",
        "tituloDestinos": "Destinations",
        "labelDestinos": "Destinations",
        "labelPartners": "Partenaires",
        "labelAyuda": "Aide",
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelone",
          "berlin": "Berlin",
          "paris": "Paris",
          "roma": "Rome",
          "dubai": "Dubaï",
          "bogota": "Bogotá",
          "mexico": "Mexico",
          "lima": "Lima",
          "panama": "Panama City"
        },
        "buttonDestinos": {
          "label": "Voir toutes les destinations",
          "link": "destinos",
          "url": false
        },
        "buttonFunciona": {
          "label": "Comment ça marche?",
          "link": "como-funciona",
          "url": false
        },
        "buttonPartner": {
          "hoteleros": "Hôteliers",
          "agencias": "Agences de voyage"
        },
        "buttonAyuda": {
          "contacto": "Contact",
          "preguntas": "Questions fréquentes"
        }
      },
      "footer": {
        "tituloPrivacidad": "Confidentialité",
        "tituloInformacion": "Information",
        "tituloHoteleros": "Hôteliers",
        "subtituloHoteleros": "Rejoignez BYHOURS!",
        "tituloAgencia": "Êtes-vous une agence?",
        "subtituloAgencia": "Rejoignez BYHOURS!",
        "tituloDestinos": "Quelques destinations",
        "tituloSiguenos": "Suivez-nous",
        "tituloApp": "Téléchargez l'application",
        "keywords": {
          "hotelesPorHoras": "Hôtels à l'heure",
          "hotelDeDia": "Hôtels de jour",
          "habitacionPorHoras": "Chambres à l'heure"
        },
        "privacidadLinks": {
          "acuerdo": "Accord d'utilisateur",
          "privacidad": "Politique de confidentialité",
          "cookies": "Politique de cookies"
        },
        "infoLinks": {
          "ayuda": "Aide",
          "contacto": "Contact",
          "blog": "Blog",
          "unete": "Rejoignez l'équipe"
        },
        "destinos": {
          "madrid": "Madrid",
          "barcelona": "Barcelone",
          "berlin": "Berlin",
          "paris": "Paris",
          "roma": "Rome",
          "dubai": "Dubaï",
          "bogota": "Bogotá",
          "mexico": "Mexico",
          "lima": "Lima",
          "panama": "Panama City",
          "zurich": "Zurich",
          "viena": "Vienne",
          "londres": "Londres",
          "milan": "Milan",
          "doha": "Doha",
          "buenosAires": "Buenos Aires",
          "quito": "Quito",
          "santiago": "Santiago du Chili"
        },
        "buttonAgencia": {
          "label": "Accès au portail"
        },
        "buttonHotelero": {
          "label": "Accès au portail"
        },
        "redes": {
          "instagram": "Instagram",
          "facebook": "Facebook",
          "x": "X",
          "linkedin": "Linkedin",
          "tiktok": "Tik Tok",
          "youtube": "Youtube"
        },
        "buttonsApp": {
          "appStore": "App Store",
          "googlePlay": "Google Play"
        }
      }
    }
  },
  "hoteliersPage": {
    "breadcrumb": {
      "home": "Accueil",
      "current": "Pour les hôteliers"
    },
    "hero": {
      "title": "Transformez les heures creuses de vos chambres en revenus",
      "description": "Vende microestancias en franjas de 3, 6 y 24 horas con las reglas que tú gestiones; franja horaria, disponibilidad y canal propio, sin compromiso de cupo.",
      "cta": "Rejoindre notre réseau d’hôtels",
      "imageAlt": "BYHOURS pour les hôteliers"
    },
    "whyTitle": "Pourquoi BYHOURS",
    "features": [
      {
        "title": "Flexibilité totale",
        "description": "Pilotez la plateforme à votre façon : comment et quand proposer des microséjours."
      },
      {
        "title": "Sans quota minimum",
        "description": "Nous n’exigeons pas un minimum de chambres. Ouvrez et fermez la disponibilité quand vous le décidez."
      },
      {
        "title": "Produit différencié",
        "description": "Distinct de la vente à la nuit : moins de problèmes de parité tarifaire sur vos canaux habituels."
      },
      {
        "title": "Revenus chambre",
        "description": "Monétisez les créneaux et les journées où la chambre ne se vend pas à la nuit."
      },
      {
        "title": "Nouveaux segments clients",
        "description": "Touchez les voyageurs d’affaires, les escales et le loisir qui réservent à l’heure."
      },
      {
        "title": "Sans engagement",
        "description": "Testez le modèle sans engagement sur la durée."
      }
    ],
    "whoWeAre": {
      "title": "Qui sommes-nous ?",
      "description": "Leaders des microséjours depuis 2012. Chiffres cumulés et réseau actuel : chaînes internationales et indépendants augmentent leur RevPAR avec BYHOURS sur des centaines de destinations.",
      "ctaQuestion": "Prêt à voir comment cela s’adapte à votre hôtel ?",
      "ctaButton": "Demander des informations"
    },
    "stats": [
      {
        "title": "+15 M€",
        "description": "Générés pour nos hôtels (cumulé)"
      },
      {
        "title": "+300 K",
        "description": "Réservations de microséjours générées"
      },
      {
        "title": "+250 K",
        "description": "Clients satisfaits"
      },
      {
        "title": "24",
        "description": "Marchés en Europe, Amérique latine et Moyen-Orient"
      },
      {
        "title": "+600",
        "description": "Destinations disponibles"
      },
      {
        "title": "+4000",
        "description": "Hôtels partenaires qui génèrent déjà des revenus supplémentaires"
      }
    ],
    "video": {
      "title": "BYHOURS pour votre hôtel",
      "description": "Découvrez comment BYHOURS peut vous aider à monétiser les chambres vacantes et augmenter vos revenus.",
      "iframeTitle": "Vidéo BYHOURS pour les hôteliers"
    },
    "widget": {
      "title": "Vendez à l’heure depuis votre propre site",
      "description": "En une ligne de code, votre site affiche un bouton flottant qui ouvre le moteur de recherche à l’heure : les clients réservent des microséjours tout de suite, sans quitter l’environnement de votre hôtel.",
      "pillars": [
        {
          "title": "Intégration en quelques minutes",
          "description": "Mise en ligne légère : pas de gros projets ni de refonte du site au-delà du snippet convenu avec votre équipe ou votre prestataire."
        },
        {
          "title": "Réservation à l’heure en un clic",
          "description": "Les visiteurs voient un bouton flottant qui ouvre le comparateur de microséjours : ils choisissent un créneau et finalisent la réservation sur votre site."
        },
        {
          "title": "Vous gardez la main",
          "description": "Prix, disponibilité et règles viennent toujours de votre extranet BYHOURS : le widget ne montre que ce que vous autorisez."
        }
      ],
      "featuresSubtitle": "Fonctionnalités du widget",
      "widgetFeatures": [
        {
          "title": "Couleurs et textes à votre marque",
          "description": "Réglez les couleurs principale et secondaire, l’arrondi du bouton et le texte du CTA ; le contenu du comparateur peut suivre vos réglages de langue."
        },
        {
          "title": "Flottant ou intégré à la page",
          "description": "Bouton dans un coin ou bloc intégré : choisissez ce qui convient à votre mise en page et à la navigation."
        },
        {
          "title": "Règles distinctes mobile et bureau",
          "description": "Définissez position, marges et comportement séparément pour grand et petit écran pour ne pas masquer le contenu important."
        }
      ],
      "cta": "Demander l’intégration",
      "figcaption": "Le bouton flottant ouvre le comparateur de microséjours sans quitter le site de l’hôtel.",
      "imageAlt": "Exemple du widget de réservation à l’heure intégré au site d’un hôtel"
    },
    "examples": {
      "title": "Trois exemples réels de clients",
      "description": "Établissements qui encaissent déjà des microséjours avec BYHOURS. Les chiffres sont des estimations indicatives selon le marché et la politique commerciale.",
      "benefitLabel": "Bénéfice pour l’hôtel",
      "bookingsLabel": "Réservations avec BYHOURS",
      "cta": "Je veux rejoindre le réseau",
      "cases": [
        {
          "badge": "Barcelone",
          "title": "Hôtel 4 étoiles",
          "description": "Marché mixte congrès, croisières et tourisme urbain : les microséjours comblent les créneaux entre nuits et la demande de dernière minute dans une zone très concurrentielle.",
          "revenue": "+700k €",
          "bookings": "+14k"
        },
        {
          "badge": "Madrid",
          "title": "Hôtel urbain",
          "description": "Hôtel sans catégorie étoiles qui intègre le canal à l’heure pour les voyageurs de passage, le télétravail et les courts séjours sans se limiter au BAR nuit.",
          "revenue": "+300k €",
          "bookings": "+7k"
        },
        {
          "badge": "Bogotá",
          "title": "Hôtel 5 étoiles",
          "description": "Profil premium dans une capitale andine : affaires, événements et clientèle corporate qui valorise des packs d’heures alignés sur des agendas serrés.",
          "revenue": "+400k €",
          "bookings": "+12k"
        }
      ]
    },
    "testimonialsTitle": "Ce que disent nos partenaires",
    "testimonials": [
      {
        "quote": "La flexibilité sur les prix et la disponibilité en dernière minute nous aide à améliorer l’ADR sur des créneaux qui restaient vides.",
        "name": "Juan Reyna",
        "role": "Director of Sales & Marketing — Hilton Barcelona",
        "kind": "hilton"
      },
      {
        "quote": "Dans un marché où les clients sont de plus en plus éclectiques, disposer d’une solution comme BYHOURS nous permet d’attirer un type de client qui ne trouve pas toujours une offre adaptée à ses besoins. De plus, une plateforme simple d’utilisation qui offre tout le contrôle et la flexibilité nécessaires fait que générer des revenus supplémentaires n’a jamais été aussi simple.",
        "name": "Xavier Micó",
        "role": "General Manager — Four Points by Sheraton",
        "kind": "marriott"
      },
      {
        "quote": "La plateforme BYHOURS propose une solution innovante et flexible pour que les hôtels maximisent l’occupation de leurs chambres. On remarque surtout la possibilité de proposer des chambres non seulement à la journée (24 h), mais aussi par tranches de 3 ou 6 heures. Cela ouvre de nouvelles opportunités pour réduire les vacances et générer des revenus supplémentaires.\n\nL’extranet est aussi très solide : claire, intuitive, et elle permet de gérer les annonces simplement et efficacement. Sans longue période de formation, on s’y retrouve vite et on utilise les fonctions essentielles sans difficulté.\n\nUn autre atout majeur est le service client : les demandes sont traitées rapidement, avec un accueil professionnel et chaleureux. On se sent bien accompagné, ce qui rend la collaboration très agréable. Dans l’ensemble, BYHOURS est une plateforme moderne et bien pensée qui convainc par sa fonctionnalité et par l’excellence de son service.",
        "name": "Robert Franke",
        "role": "Channelmanagement Coordinator — GHC Hotels",
        "kind": "ghc"
      },
      {
        "quote": "BYHOURS est devenu un outil essentiel pour notre exploitation quotidienne. Il offre une flexibilité maximale dans la gestion de la disponibilité, des tarifs, de la création de forfaits sur mesure et un contrôle total de la stratégie commerciale, ce qui permet une adaptation immédiate aux fluctuations du marché, aux annulations, aux départs anticipés, etc.\n\nL’impact sur le chiffre d’affaires a été très positif : nous avons enregistré une hausse significative des revenus. Son interface intuitive, sa grande flexibilité et l’exceptionnelle qualité du service client facilitent grandement les processus, réduisent le temps de gestion et minimisent les erreurs opérationnelles.\n\nC’est aujourd’hui un complément indispensable pour notre hôtel.",
        "name": "Anonyme",
        "role": "Partenaire hôtelier",
        "kind": "anonymous"
      }
    ],
    "demand": {
      "title": "Votre hôtel touche ces profils de demande",
      "description": "Voici comment réservent à l’heure ceux qui cherchent votre hôtel : couvrir ces segments augmente l’occupation et les revenus au-delà du seul schéma nuit entière.",
      "items": [
        {
          "title": "Affaires et travail",
          "paragraph": "Professionnels qui ont besoin de Wi‑Fi, d’une pause entre deux rendez-vous ou d’intimité hors bureau. Ils réservent des plages diurnes qui s’alignent sur votre inventaire entre les nuits."
        },
        {
          "title": "Voyageurs",
          "paragraph": "Passagers en correspondance, retards ou longues attentes : douche, repos et confort près de l’aéroport ou de la gare. Votre hôtel répond à un besoin que la nuit seule ne couvre pas toujours."
        },
        {
          "title": "Style de vie et loisirs",
          "paragraph": "Spa, piscine ou terrasse avant ou après concerts, shopping ou week-ends urbains. Vous captez un loisir qui préfère payer seulement les heures utilisées."
        }
      ]
    },
    "steps": {
      "title": "Comment faire partie de BYHOURS ?",
      "description": "Générer des revenus avec BYHOURS est simple. En trois étapes vous commencez à monétiser vos chambres vacantes.",
      "items": [
        {
          "title": "Inscription",
          "description": "Remplissez le formulaire et nous vous recontactons.",
          "linkToForm": true
        },
        {
          "title": "Formation",
          "description": "Lors d’un court onboarding vous chargez votre première disponibilité et apprenez à utiliser la plateforme.",
          "linkToForm": false
        },
        {
          "title": "Vente",
          "description": "Votre hôtel est en ligne : vous vendez et monétisez les chambres vacantes avec BYHOURS.",
          "linkToForm": false
        }
      ]
    },
    "form": {
      "title": "Rejoignez notre réseau d’hôtels",
      "description": "Envoyez votre demande et nous vous recontacterons dès que possible pour parler de votre hôtel et des prochaines étapes. Les informations servent uniquement à répondre à votre demande ; responsable du traitement : BYHOURS Travel S.L.",
      "successTitle": "Demande envoyée",
      "successDescription": "Merci. Nous avons bien reçu votre message et vous contacterons dès que possible.",
      "hotelSection": "Données de l’hôtel",
      "contactSection": "Contact",
      "hotelName": "Nom de l’hôtel",
      "website": "Site web (optionnel)",
      "rooms": "Nombre de chambres",
      "roomsPlaceholder": "Choisissez une fourchette…",
      "cityCountry": "Localisation de l’hôtel",
      "cityPlaceholder": "Rechercher une ville…",
      "contactName": "Nom du contact",
      "email": "E-mail",
      "phone": "Téléphone",
      "comments": "Commentaires (optionnel)",
      "commentsPlaceholder": "Dites-nous ce dont vous avez besoin : collaboration, intégration du widget, questions commerciales…",
      "privacyBefore": "J'accepte la ",
      "privacyLink": "politique de confidentialité",
      "privacyAfter": " et le traitement de mes données pour répondre à cette demande.",
      "submit": "Envoyer la demande",
      "websitePlaceholder": "https://hotel.example.com"
    },
    "faq": {
      "title": "Des questions ?",
      "description": "Réponses aux questions fréquentes des revenue managers et des équipes commerciales.",
      "items": [
        {
          "label": "Qu’est-ce qu’un microséjour ?",
          "content": "Une réservation hôtel de 3, 6 ou 24 heures où le client choisit l’heure d’arrivée dans la journée. Vous contrôlez prix et disponibilité par créneau."
        },
        {
          "label": "Y a-t-il un quota minimum ou un engagement ?",
          "content": "Nous n’exigeons ni minimum de chambres ni durée d’engagement. Vous pouvez tester le modèle et l’ajuster selon vos besoins."
        },
        {
          "label": "Cela impacte-t-il le BAR ou le yield ?",
          "content": "Le produit est une ligne différenciée pour d’autres segments (affaires, escales, dernière minute), en comblant les creux sans remplacer la vente nuit."
        },
        {
          "label": "Comment fixe-t-on le prix par créneau ?",
          "content": "Vous définissez tarifs et règles des microséjours dans l’extranet selon votre stratégie. Notre équipe vous aide à la configuration initiale."
        },
        {
          "label": "Y a-t-il des commissions ou un partage de revenus ?",
          "content": "Les conditions commerciales (commissions, règlements) se fixent à l’adhésion au programme partenaire. Nous les détaillons lors du premier échange après votre demande."
        },
        {
          "label": "S’intègre-t-il à mon PMS ou channel manager ?",
          "content": "Nous étudions les intégrations selon votre stack. Indiquez vos systèmes dans le formulaire ou lors de l’appel d’accueil et nous trouverons la meilleure option."
        },
        {
          "label": "Comment fonctionne la facturation client et hôtel ?",
          "content": "BYHOURS encaisse le client selon le flux prévu dans votre contrat partenaire ; nous expliquons facturation et règlements lors de l’onboarding."
        },
        {
          "label": "De quoi ai-je besoin pour commencer ?",
          "content": "Remplissez le formulaire sur cette page. Notre équipe vous accompagne pour la configuration et la première mise en ligne de disponibilité sur l’extranet."
        }
      ]
    },
    "toast": {
      "validationTitle": "Vérifiez le formulaire"
    },
    "errors": {
      "server": "L'envoi a échoué. Réessayez.",
      "rateLimit": "Trop de demandes envoyées. Réessayez dans quelques minutes."
    },
    "validation": {
      "hotelName": "Indiquez le nom de l'hôtel",
      "websiteMax": "URL du site trop longue",
      "rooms": "Sélectionnez une fourchette de chambres",
      "cityCountry": "Indiquez la ville et le pays",
      "contactName": "Indiquez le nom du contact",
      "emailRequired": "Indiquez votre e-mail",
      "emailInvalid": "E-mail invalide",
      "phone": "Indiquez un téléphone",
      "commentsMax": "4000 caractères maximum",
      "privacy": "Vous devez accepter la politique de confidentialité"
    },
    "roomRanges": [
      {
        "label": "1 – 9",
        "value": "1-9"
      },
      {
        "label": "10 – 19",
        "value": "10-19"
      },
      {
        "label": "20 – 59",
        "value": "20-59"
      },
      {
        "label": "60 – 99",
        "value": "60-99"
      },
      {
        "label": "100 ou plus",
        "value": "100+"
      }
    ]
  }
}
